export function createGetSpeakerIndex(): (speaker: string) => number {
    const speakers: string[] = [];

    return (speaker: string) => {
        let index = speakers.indexOf(speaker);

        if (index === -1) {
            index = speakers.push(speaker) - 1;
        }

        return index;
    };
}
